import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import {
  ALL_CATEGORIES_DE_SELECTED,
  ALL_CATEGORIES_SELECTED,
  ALL_MAIL_CLASSES_DE_SELECTED,
  ALL_MAIL_CLASSES_SELECTED,
  MAIL_CLASS_EXPANDED,
  MAIL_CLASS_SELECTED,
} from '../actions/types/ProductActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

const initialState = {
  selected: [],
  expanded: [],
};

export default function mailCategoryReducer(state = initialState, action, allMailSubClassCodes) {
  switch (action.type) {
    case MAIL_CLASS_SELECTED:
      return { ...state, selected: (action.selected.length > 0 && action.propogateSelectionToRoot) ? allMailSubClassCodes : action.selected };
    case MAIL_CLASS_EXPANDED:
      return { ...state, expanded: action.expanded };
    case ALL_CATEGORIES_SELECTED:
    case ALL_MAIL_CLASSES_SELECTED:
      return { ...state, selected: allMailSubClassCodes };
    case ALL_CATEGORIES_DE_SELECTED:
    case ALL_MAIL_CLASSES_DE_SELECTED:
      return { ...state, selected: [] };
    case ENTERED_WIZARD:
      return initialState;
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
}

